export default "__VITE_ASSET__DBUblO9K__"